"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyAssetsInitRequest = void 0;
var MyAssetsInitRequest = /** @class */ (function () {
    function MyAssetsInitRequest() {
    }
    return MyAssetsInitRequest;
}());
exports.MyAssetsInitRequest = MyAssetsInitRequest;
;
//# sourceMappingURL=myAssetsInit.request.js.map